module.exports = __webpack_public_path__ + "static/img/yinliangjian.86f8829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliangjian.png
// module id = 6N2q
// module chunks = 24